import { HelpIndex, HelpTopicView } from '../components/help.js';

/**
 * The panel help center: every module's staff-facing documentation,
 * searchable and readable in-app.
 */
export function HelpPage() {
  return <HelpIndex shell="panel" />;
}

export function HelpTopicPage() {
  return <HelpTopicView shell="panel" />;
}
